var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEclipse1X10S200Px200Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgba(255, 255, 255, 0)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#00bce4",
    d: "M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0 50 51;360 50 51",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    dur: "1s",
    type: "rotate",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse1X10S200Px200Px);
export default __webpack_public_path__ + "static/media/Eclipse@1x-1.0s-200px-200px.3f111b252e6121d41e20d5bf2950b77c.svg";
export { ForwardRef as ReactComponent };